import React, {Component} from 'react';

class About extends Component {
    render() {
        return <p>Company Manual v2.0 build 1.01 27/01/2020</p>
    }
}

export default About